import cls from './Progress.module.css';
import { CreditRiskProgressProps } from '@types';


const IconYes = () => (
  <svg width="1em" height="1em" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M7 0C10.866 0 14 3.13401 14 7C14 10.866 10.866 14 7 14C3.13401 14 0 10.866 0 7C0 3.13401 3.13401 0 7 0ZM11.1885 4.75879C10.7889 4.40039 10.1588 4.41659 9.78027 4.79492L6.35254 8.2207L4.18262 6.27344C3.7832 5.91492 3.15207 5.93046 2.77344 6.30859C2.39485 6.68707 2.41198 7.28493 2.81152 7.64355L5.70508 10.2412C5.73006 10.2636 5.75555 10.2852 5.78223 10.3047C6.18212 10.5968 6.75941 10.5598 7.11426 10.2051L11.2266 6.09375C11.6052 5.71528 11.588 5.11741 11.1885 4.75879Z" fill="#0C5541"/>
  </svg>
);

const IconNo = () => (
  <svg width="1em" height="1em" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M7 0C10.866 0 14 3.13401 14 7C14 10.866 10.866 14 7 14C3.13401 14 0 10.866 0 7C0 3.13401 3.13401 0 7 0ZM6.13965 5.08008V11.7998H7.67969V5.08008H6.13965ZM6.91016 2C6.6489 2 6.42926 2.0884 6.25195 2.26562C6.08399 2.44292 6.00004 2.66257 6 2.92383C6 3.18516 6.08396 3.4047 6.25195 3.58203C6.42929 3.75936 6.64882 3.84766 6.91016 3.84766C7.18075 3.84762 7.40039 3.75933 7.56836 3.58203C7.73626 3.40473 7.82031 3.18508 7.82031 2.92383C7.82028 2.66257 7.73632 2.44292 7.56836 2.26562C7.40039 2.08834 7.18074 2.00003 6.91016 2Z" fill="#F38336"/>
  </svg>
);

export const Progress = (
  { percent, options }: CreditRiskProgressProps,
) => {
  return (
    <div className={cls.wrap}>
      <div className={cls.header}>
        <span className={cls.title}>Analysis Progress</span>
        <span className={cls.percent}>{percent || 0}%</span>
      </div>
      <div className={cls.body}>
        {(options ? Object.entries(options) : []).map(([key, value], idx) => (
          <div className={cls.row} key={idx}>
            <span className={cls.col}>{value ? <IconYes /> : <IconNo />}</span>
            <span className={cls.col}>{key}</span>
          </div>
        ))}
      </div>
    </div>
  );
};
